var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('Footer-Top'),_c('Footer-Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }